<template>
    <div class="d-flex align-items-center justify-content-around p-3 bg-light rounded shadow-sm mb-4">
      <div class="text-center">
        <font-awesome-icon :icon="['fas', 'hand-holding-dollar']" class="me-1 text-secondary" />
        <span class="font-weight-bold">Costo Real: </span>
        <span class="badge bg-success rounded-pill fs-5">{{ costoTotalTareasDolares }} $</span>
      </div>
      <div class="text-center">
        <font-awesome-icon :icon="['far', 'clock']" class="me-1 text-secondary" />
        <span class="font-weight-bold">Tiempo Total: </span>
        <span class="badge bg-info rounded-pill fs-5">{{ horasTotalTareas }} h</span>
      </div>
      <div class="text-center">
        <font-awesome-icon :icon="['fas', 'tasks']" class="me-1 text-secondary" />
        <span class="font-weight-bold">Tareas: </span>
        <span class="badge bg-primary rounded-pill fs-5">{{ totalTareas }}</span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      costoTotalTareasDolares: Number,
      horasTotalTareas: Number,
      totalTareas: Number,
    },
  };
  </script>
  